var Backbone = require('backbone');

/**
 * Sub-object of the document model.
 * With Feith Drive permissions, these are at the document level.
 */

module.exports = Backbone.Model.extend({

    defaults: {
        "addPages": false,
        "deletePages": false,
        "reorderPages": false,
        "rotatePages": false,
        "createPageNotes": false,
        "createDocumentNotes": false,
        "modifyOrDeleteNotes": false,
        "createHighlights": false,
        "modifyOrDeleteHighlights": false
    },

    canAddPages: function() {
        return this.get('addPages');
    },

    canDeletePages: function() {
        return this.get('deletePages');
    },

    canReorderPages: function() {
        return this.get('reorderPages');
    },

    // Currently undecided if Feith Drive perm weighs on this
    canSavePageRotation: function() {
       return 1;
        //return this.get('rotatePages');

    },
    /* All page notes except highlight  */
    canCreatePageNotes: function() {
        return this.get( 'createPageNotes' );
    },

    canCreateDocNotes: function() {
        return this.get('createDocumentNotes');
    },

    /* Applicable to both doc and page notes -- except Highlights */
    canModifyOrDeleteNotes: function() {
        return this.get('modifyOrDeleteNotes');
    },

    canCreateHighlights: function() {
        return this.get('createHighlights');
    },

    canModifyOrDeleteHighlights: function() {
        return this.get('modifyOrDeleteHighlights');
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/contextualPermissions.js
 ** module id = 410
 ** module chunks = 0
 **/